import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/qui-sommes-nous', label: 'Qui sommes-nous' },
    { path: '/nos-services', label: 'Nos services' },
    { path: '/contact', label: 'Contact' },
  ];

  const services = [
    { path: '/service/bien-etre-vitalite-travail', label: 'Bien-être au travail' },
    { path: '/service/massotherapie-professionnelle', label: 'Massothérapie' },
    { path: '/service/vr-massage-relaxation', label: 'VR Massage' },
    { path: '/maternity-zen', label: 'Maternity Zen' },
  ];

  return (
    <footer className="bg-gradient-to-br from-primary via-primary-dark to-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-3">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/a0897f463ac1d23797a54fc0386c922a/6327f16851a102624ec13fca55a36d08.png" 
                alt="HMC CLINIC Logo" 
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Votre partenaire bien-être à Lubumbashi pour une vie plus saine et équilibrée.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/share/1DJzFtcnY2/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/hmcclinicrdc?igsh=MTFkeDgxMGt5eDdjcQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://tiktok.com/@hmcclinic2"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/243850465500"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="text-lg font-semibold mb-5">Liens rapides</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold mb-5">Nos services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-4">
            <h4 className="text-lg font-semibold mb-5">Restez informé</h4>
            <p className="text-gray-300 text-sm mb-4">
              Recevez nos conseils bien-être et nos actualités directement dans votre boîte mail.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Votre email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-l-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/40 text-sm"
              />
              <button className="px-6 py-3 bg-accent hover:bg-accent-dark rounded-r-lg transition-colors flex items-center justify-center cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">
            © {currentYear} HMC CLINIC. Tous droits réservés.
          </p>
          <div className="flex items-center space-x-6">
            <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Politique de confidentialité
            </Link>
            <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Conditions d'utilisation
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
